module.exports = __webpack_public_path__ + "static/media/videos_resourcecea5f934.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/videos_resource.svg
// module id = 1537
// module chunks = 0